import React from "react";

import { useAppSelector } from "../../../app/hooks";

import { selectCaseHeader } from "../../caseinfo/logic/Slice";
import ManageEntitiesModal from "./ManageEntitiesModal";



interface ManagePartyModalProps {
  onClose: () => void;
  onAdd: () => void;
}

const ManagePartyModal: React.FC<ManagePartyModalProps> = ({
  onClose,
  onAdd,
}) => {
  const caseData = useAppSelector(selectCaseHeader);

  const parties = caseData?.parties_involved || [];

  const items = parties.map(party => ({
    id: party.party_id,
    title: party.name,
    subtitle: party.party_type,
  }));

  return (
    <ManageEntitiesModal
      title="Party Details"
      items={items}
      addButtonTitle="Add New Party"
      onClose={onClose}
      onAdd={onAdd}
    />
  );
};

export default ManagePartyModal;